module.exports = __webpack_public_path__ + "img/favicon.f274569f.png";